import Login from '../pages/auth/login';

// routes
const AuthRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '*',
    element: <Login />,
  },
];

export default AuthRoutes;
